(() => {
  const officialHost = [
    110, 97, 107, 101, 100, 97, 110, 100,
    102, 97, 109, 111, 117, 115, 100, 101,
    110, 105, 109, 46, 99, 111, 109
  ].map((code) => String.fromCharCode(code)).join('');

  const allowedHosts = new Set([
    officialHost,
    ['www', officialHost].join('.'),
    'tate-yoko-2.myshopify.com',
    'tateandyoko.com',
    'www.tateandyoko.com',
    'shop.tateandyoko.com'
  ]);

  const currentHost = window.location.hostname.toLowerCase();
  const isShopifyEditor = Boolean(
    window.Shopify && window.Shopify.designMode === true
  );
  const isShopifyEnvironment =
    currentHost.endsWith('.myshopify.com') ||
    currentHost.endsWith('.shopifypreview.com') ||
    isShopifyEditor;

  if (!isShopifyEnvironment && !allowedHosts.has(currentHost)) {
    window.location.replace(
      'https://' +
        officialHost +
        window.location.pathname +
        window.location.search +
        window.location.hash
    );
  }
})();
